/* src/app/features/purchase-requests/quote-request/quote-request.component.css */
.actions-group-buttons {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 46px;
}
.footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: solid 2px rgba(128, 128, 128, 0.176);
  flex-wrap: nowrap;
}
/*# sourceMappingURL=quote-request.component.css.map */
